import { useState, useEffect } from 'react';
import { DomData } from './dom';

export const Routes = () => {
    const { isBrowser } = DomData();
    const [hash, setHash] = useState(
        isBrowser ? window.location.hash.replace('#', '') : ''
    );

    useEffect(() => {
        if (hash) {
            window.history.replaceState(null, null, `#${hash}`);
        } else {
            window.history.replaceState(null, null, ``);
        }
    }, [hash]);

    useEffect(() => {
        if (isBrowser) {
            function updateHash() {
                setHash(window.location.hash.replace('#', ''));
            }
            document.addEventListener('hashchange', updateHash);
            updateHash();
            return () => document.removeEventListener('hashchange', updateHash);
        }
    }, [isBrowser]);

    return { hash, setHash };
};

export const matchCurrentPath = (path, compare) => {
    // Early return if either path is missing/invalid
    if (!path || !compare) return false;

    // Special case for home - only match exact root path
    if (compare === '/home/' || compare === '/') {
        return path === '/' || path === '/home/';
    }

    // Normalize paths
    const normalizedCompare = compare.replace('/home', '').replace(/\/$/, '');
    const normalizedPath = path.replace(/\/$/, '');

    // Simple includes check for path matching
    const isMatch = normalizedPath.includes(normalizedCompare);

    // Special case for About section
    if (compare.includes('/about/')) {
        return isMatch || normalizedPath.includes('/news-insights');
    }

    return isMatch;
};
